<template>
  <div id="app">
    <Header />
    <Sidebar />
    <Playground />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import Header from '@/components/Header.vue';
import Sidebar from '@/components/Sidebar.vue';
import Playground from '@/components/Playground.vue';

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Playground,
  },
  mounted() {
    this.setProduct();
  },
  methods: {
    ...mapActions(['setProduct']),
  },
};
</script>

<style lang="less">
@import "~@/less/common.less";

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
}

#app {
  display: grid;
  grid-template-columns: 20% 80%;
  grid-template-rows: 60px 1fr;
  grid-template-areas:
    "header header"
    "sidebar playground";
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #F0EEE9;
}

</style>
